import { render, staticRenderFns } from "./problemToChange.vue?vue&type=template&id=65371889&scoped=true&"
import script from "./problemToChange.vue?vue&type=script&lang=js&"
export * from "./problemToChange.vue?vue&type=script&lang=js&"
import style0 from "./problemToChange.vue?vue&type=style&index=0&id=65371889&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65371889",
  null
  
)

export default component.exports